import { useState, useEffect, useContext } from "react";
import axios from "axios";
import "./assets/css/editblogmodel.css";
import { AppContext } from "../../context/AppContext";

const EditBlog = ({ blogId, onClose, onUpdated }) => {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    categoryType: "",
    authorName: "",
    metaTitle: "",
    metaKeyword: "",
    metaDescription: "",
    imagePath: "",
    authorImagePath: "",
    blogStatus: true,
    url_key: "",
  });

  // Image handling state
  const [thumbnail, setThumbnail] = useState(null);
  const [preview, setPreview] = useState(null);
  const [authorImage, setAuthorImage] = useState(null);
  const [authorPreview, setAuthorPreview] = useState(null);
  const [uploadImgMsg, setUploadImgMsg] = useState("");
  const [uploadAuthorImgMsg, setUploadAuthorImgMsg] = useState("");
  const [status, setStatus] = useState("");
  const [isError, setIsError] = useState(false);
  const { baseUrl, Backend_folder_path, token } = useContext(AppContext);
  const adminurl = "http://localhost:4000/api";

  useEffect(() => {
    const editGame = async () => {
      if (!blogId) return;
      const res = await axios.get(`${baseUrl}/blog/${blogId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res) {
        setFormData(res.data.blog);
      }
    };
    editGame();
  }, [blogId]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    if (type === "thumbnail") {
      setThumbnail(file);
      setPreview(URL.createObjectURL(file));
    } else if (type === "author") {
      setAuthorImage(file);
      setAuthorPreview(URL.createObjectURL(file));
    }
  };

  const handleThumbUpload = async (e, type) => {
    e.preventDefault();
    const file = type === "thumbnail" ? thumbnail : authorImage;
    const msgSetter =
      type === "thumbnail" ? setUploadImgMsg : setUploadAuthorImgMsg;

    if (!file) {
      msgSetter(`Please select a ${type} image first!`);
      return;
    }

    const formData = new FormData();
    formData.append(
      type === "thumbnail" ? "blog_images" : "blog_author_images",
      file
    );

    try {
      const endpoint =
        type === "thumbnail"
          ? `${baseUrl}/upload-blog-images`
          : `${baseUrl}/upload-blog-author-images`;

      const res = await axios.post(endpoint, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      msgSetter(
        `${
          type.charAt(0).toUpperCase() + type.slice(1)
        } image uploaded successfully`
      );
      setFormData((prev) => ({
        ...prev,
        [type === "thumbnail" ? "imagePath" : "authorImagePath"]:
          type === "thumbnail"
            ? `/blog/blog_images/${file.name}`
            : `/blog/blog_author_images/${file.name}`,
      }));
    } catch (err) {
      console.error(err);
      msgSetter(`Failed to upload ${type} image: ${err.message}`);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setStatus("Updating blog...");
      setIsError(false);

      const response = await axios.put(
        `${baseUrl}/blog-update/${blogId}`,
        {
          title: formData.title,
          description: formData.description,
          categoryType: formData.categoryType,
          authorName: formData.authorName,
          metaTitle: formData.metaTitle,
          metaKeyword: formData.metaKeyword,
          metaDescription: formData.metaDescription,
          imagePath: formData.imagePath,
          authorImagePath: formData.authorImagePath,
          blogStatus: formData.blogStatus,
          url_key: formData.url_key,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data && response.data.success !== false) {
        setStatus("Blog updated successfully!");
        setIsError(false);
        onUpdated();
        setTimeout(onClose, 1000);
      } else {
        setStatus(
          "Error updating blog: " + (response.data.message || "Unknown error")
        );
        setIsError(true);
      }
    } catch (err) {
      setStatus(
        "Error updating blog: " + (err.response?.data?.message || err.message)
      );
      setIsError(true);
    }
  };

  return (
    <div className="model_main">
      <h3>Edit Blog</h3>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="form_field">
          <label>
            <input
              type="checkbox"
              name="blogStatus"
              checked={formData.blogStatus}
              onChange={handleChange}
            />
            <span>
              {" "}
              {formData.blogStatus ? "Public" : "Unpublic"} Blog ({" "}
              <small>You can Public or Unpublic blog as you wish.</small>)
            </span>
          </label>
        </div>
        <div className="form_field">
          <label>Blog Title *</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
            placeholder="Enter blog title"
          />
        </div>
        <div className="form_field">
          <label>Url Key</label>
          <input
            type="text"
            name="url_key"
            value={formData.url_key}
            onChange={handleChange}
            required
            className="form-control"
            placeholder="Enter URL key"
          />
        </div>
        <div className="form_field">
          <label>Blog Description</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Enter blog description"
            rows="3"
          />
        </div>
        <div className="form_field">
          <label>Blog Category</label>
          <input
            type="text"
            name="categoryType"
            value={formData.categoryType}
            onChange={handleChange}
            placeholder="Enter blog tags (comma separated)"
            required
            className="form-control"
          />
        </div>
        <div className="form_description">
          <label>Blog Image</label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange(e, "thumbnail")}
          />
          {preview && (
            <img
              src={preview}
              alt="Blog Image Preview"
              style={{ width: "100px", height: "100px", marginTop: "10px" }}
            />
          )}
          <small>Current: {formData.imagePath}</small>

          <button
            type="button"
            onClick={(e) => handleThumbUpload(e, "thumbnail")}
            disabled={!thumbnail}
          >
            Upload Blog Image
          </button>
          {uploadImgMsg && (
            <p
              style={{
                color: uploadImgMsg.includes("Failed") ? "red" : "green",
              }}
            >
              {uploadImgMsg}
            </p>
          )}
        </div>
        <div className="form_field">
          <label>Author Name</label>
          <input
            type="text"
            name="authorName"
            value={formData.authorName}
            onChange={handleChange}
            placeholder="Enter author name"
            className="form-control"
          />
        </div>
        <div className="form_description">
          <label>Author Image</label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange(e, "author")}
          />
          {authorPreview && (
            <img
              src={authorPreview}
              alt="Author Image Preview"
              style={{ width: "100px", height: "100px", marginTop: "10px" }}
            />
          )}
          <small>Current: {formData.authorImagePath}</small>

          <button
            type="button"
            onClick={(e) => handleThumbUpload(e, "author")}
            disabled={!authorImage}
          >
            Upload Author Image
          </button>
          {uploadAuthorImgMsg && (
            <p
              style={{
                color: uploadAuthorImgMsg.includes("Failed") ? "red" : "green",
              }}
            >
              {uploadAuthorImgMsg}
            </p>
          )}
        </div>
        <h4>SEO Settings</h4>
        <div className="form_field">
          <label>Meta Title</label>
          <input
            type="text"
            name="metaTitle"
            value={formData.metaTitle}
            onChange={handleChange}
            placeholder="Enter SEO title"
            className="form-control"
          />
        </div>
        <div className="form_field">
          <label>Meta Keywords</label>
          <input
            type="text"
            name="metaKeyword"
            value={formData.metaKeyword}
            onChange={handleChange}
            placeholder="Enter meta keywords"
            className="form-control"
          />
        </div>
        <div className="form_field">
          <label>Meta Description</label>
          <textarea
            name="metaDescription"
            value={formData.metaDescription}
            onChange={handleChange}
            rows="3"
            cols="40"
            placeholder="Enter SEO meta description..."
            className="form-control"
          />
        </div>
        <div className="form_btn">
          <button type="submit">Update Blog</button>
          <button
            type="button"
            className="cancle"
            onClick={onClose}
            style={{ marginLeft: "10px" }}
          >
            Cancel
          </button>
        </div>
        {status && (
          <div style={{ marginTop: "10px", color: isError ? "red" : "green" }}>
            {status}
          </div>
        )}
      </form>
    </div>
  );
};

export default EditBlog;
